import { connect } from 'react-redux';

import { fetchMonitoringEvents } from 'api/events/events.actions';
import { fetchAllStatistics, fetchStatistics } from 'api/statistics/statistics.actions';
import { Monitoring } from './Monitoring';

const mapDispatchToProps = (dispatch: Function) => ({
  fetchEvents: ({ archived = false, active = false }) => dispatch(fetchMonitoringEvents(archived, active)),
  fetchStatistics: (eventIds: string[]) => dispatch(eventIds.length ? fetchStatistics(eventIds) : fetchAllStatistics()),
});

export const MonitoringContainer = connect(null, mapDispatchToProps)(Monitoring);
